module.exports = __webpack_public_path__ + "static/media/unlock-credit-banner.cba0f635.jpg";